export default {
  'transaction.title': '交易记录',

  'transaction.filter.search': '关键字搜索',
  'transaction.filter.dateRange': '按时间段查询',
  'transaction.filter.paymentStatus': '支付状态',
  'transaction.filter.refundStatus': '退款状态',
  'transaction.filter.paymentType': '支付方式',

  'transaction.search.placeholder': '订单号/小票号/桌号/卡号后4位',
  'transaction.search.placeholder1': '订单号',
  'transaction.status.placeholder': '单选',

  'transaction.column.time': '创建时间',
  'transaction.column.orderNumber': '订单号',
  'transaction.column.cardLast4digit': '卡号后4位',
  'transaction.column.tip': '小费',
  'transaction.column.fees': '费用',
  'transaction.column.total': '支付总金额',
  'transaction.column.status': '支付状态',
  'transaction.column.settleStatus': '结算状态',
  'transaction.column.paymentStatus': '支付状态',
  'transaction.column.refundStatus': '退款状态',
  'transaction.column.totalRefund': '退款总金额',
  'transaction.column.paymentType': '支付方式',

  'transaction.refund.title': '选择退款方式',

  'transaction.canotRefund.tips': '抱歉，我们只支持60天内订单的退款。不便之处，敬请原谅',

  'transaction.action.fullRefund': '全额退款',
  'transaction.action.partiallyRefund': '按金额退款',

  'transaction.refund.promptTitle': '退款提示',
  'transaction.refund.promptContent': '确认要为订单 {orderNo} 退款 {amount} 吗？',

  'transaction.refund.cannotFund': '不能完成该退款',
  'transaction.refund.amount': '退款金额',
  'transaction.refund.total': '账单总额',
  'transaction.refund.tips': '小费',
  'transaction.refund.totalRefunded': '已退',
  'transaction.refund.includeTips': '包含小费',

  'transaction.receipt.subtotal': '订单小计',
  'transaction.receipt.fees': '费用',
  'transaction.receipt.tax': '税',
  'transaction.receipt.discount': '折扣',
  'transaction.receipt.tips': '小费',
  'transaction.receipt.total': '订单合计',
  'transaction.receipt.cardNumber': '信用卡号',
  'transaction.receipt.transactionNumber': '交易号',
  'transaction.receipt.splitPayment': '分单支付',
  'transaction.receipt.normalPayment': '支付方式',
  'transaction.receipt.paymentTotal': '支付金额',
  'transaction.receipt.customerSignature': '客户签名',
};
